import { createStore } from "vuex";
import * as fb from "../firebase";
import graphemeSplitter from "../services/grapheme-splitter";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { query, orderBy, limit, where } from "firebase/firestore";
import {
  onSnapshot,
  doc,
  getDoc,
  getDocs,
  addDoc,
  deleteDoc,
  collection,
  setDoc,
  updateDoc,
  increment,
  deleteUser,
} from "firebase/firestore";
import router from "../router/index";

const store = createStore({
  state: {
    userProfile: null,
    posts: [],
    comments: [],
    notifications: [],
    guess: [],
    status: [],
    users: [],
    post: {},
    adminId: [],
    splashMessage: null,
    error: null,
    loading: false,
    commentsShow: false,
    commentsLimit: 10,
    limit: 10,
    randomLetter: null,
    answer: null,
  },
  mutations: {
    setUserProfile(state, payload) {
      state.userProfile = payload;
    },
    setPosts(state, payload) {
      state.posts = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setComments(state, payload) {
      state.comments = payload;
    },
    setNotif(state, payload) {
      state.notifications = payload;
    },
    setGuess(state, payload) {
      state.guess = payload;
    },
    setStatus(state, payload) {
      state.status = payload;
    },
    setSinglePost(state, payload) {
      state.post = payload[0];
      state.randomLetter = payload[1];
      
    },
    setRandomLetter(state, payload) {
      state.randomLetter = payload;
    },
    setAnswer(state, payload) {
      state.answer = payload;
    },

    setUsers(state, payload) {
      state.users = payload;
    },
    setAdminId(state, payload) {
      state.adminId = payload;
    },
    setSplash(state, payload) {
      state.splashMessage = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
  },
  actions: {
    async fetchAdminId({ commit }) {
      const queryAdminId = query(
        collection(fb.db, "users"),
        where("admin", "==", true)
      );
      const getAdminId = await getDocs(queryAdminId);
      const adminIdArray = [];
      getAdminId.forEach(async (docs) => {
        adminIdArray.push(docs.id);
      });
      commit("setAdminId", adminIdArray);
    },
    async fetchAllPosts({ commit, state }) {
      const filterPost = [state.userProfile.id, ...state.userProfile.following];
      const postsCollection = query(
        collection(fb.db, "posts"),
        orderBy("createdOn", "desc"),
        where("userId", "in", filterPost),
        limit(state.limit)
      );
      onSnapshot(postsCollection, (snapshot) => {
        let postsArray = [];

        snapshot.forEach((docs) => {
          let post = docs.data();
          post.id = docs.id;
          postsArray.push(post);
        });

        commit("setPosts", postsArray);
      });
    },
    async fetchAllNotifs({ commit, state }) {
      const userId = state.userProfile.id;
      const notifsCollection = query(
        collection(fb.db, "notifications"),
        orderBy("createdOn", "desc"),
        where("targetUserId", "==", userId),
        limit(20)
      );
      onSnapshot(notifsCollection, (snapshot) => {
        let postsArray = [];

        snapshot.forEach((docs) => {
          let post = docs.data();
          post.id = docs.id;
          postsArray.push(post);
        });
        commit("setNotif", postsArray);
      });
    },
    async fetchSplashNotifs({ commit, state, dispatch }) {
      const userId = state.userProfile.id;
      const notifsCollection = query(
        collection(fb.db, "notifications"),
        orderBy("createdOn", "desc"),
        where("targetUserId", "==", userId)
      );
      onSnapshot(notifsCollection, (snapshot) => {
        snapshot.forEach((docs) => {
          let post = docs.data();
          post.id = docs.id;
          if (post.splashMessage == true) {
            commit("setSplash", post);
            dispatch("timeOutMessage", post.id);
          }
        });
      });
    },
    timeOutMessage({ dispatch }, postId) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(dispatch("closeSplashMessage", postId));
        }, 3000);
      });
    },
    async fetchCommentsPost({ commit, state }, postId) {
      const commentsCollection = query(
        collection(fb.db, "comments"),
        orderBy("createdOn", "desc"),
        where("postId", "==", postId),
        limit(state.commentsLimit)
      );
      onSnapshot(commentsCollection, (snapshot) => {
        let commentsArray = [];

        snapshot.forEach((doc) => {
          let post = doc.data();
          post.id = doc.id;

          commentsArray.push(post);
        });

        commit("setComments", commentsArray);
      });
    },
    fetchGuessPosts({ commit, state }) {
      const postsCollection = query(
        collection(fb.db, "posts"),
        orderBy("createdOn", "desc"),
        where("type", "in", ["guess"]),
        limit(state.limit)
      );
      onSnapshot(postsCollection, (snapshot) => {
        let postsArray = [];

        snapshot.forEach((doc) => {
          let post = doc.data();
          post.id = doc.id;

          postsArray.push(post);
        });

        commit("setGuess", postsArray);
      });
    },
    async fetchStatusPosts({ commit, state }) {
      const postsCollection = query(
        collection(fb.db, "posts"),
        orderBy("createdOn", "desc"),
        where("type", "in", ["status"]),
        limit(state.limit)
      );
      onSnapshot(postsCollection, (snapshot) => {
        let postsArray = [];

        snapshot.forEach((doc) => {
          let post = doc.data();
          post.id = doc.id;

          postsArray.push(post);
        });

        commit("setStatus", postsArray);
      });
    },
    async fetchSinglePost({ commit }, postId) {
      onSnapshot(doc(fb.db, "posts", postId), (doc) => {
        const data = doc.data();
        commit("setSinglePost", [
          data,
          data.content.letter,
        ]);
        //  commit("setRandomLetter", data.content.letter);

        //  commit("setAnswer", data.content.answer);
      });
    },
    async fetchSinglePostAnswer({ commit }, postId) {
      const getAnswer = doc(fb.db,"posts",postId)
      const dataPost = await getDoc(getAnswer);
      const answer = dataPost.data().content.answer;
     return answer;
    },
    async fetchSingleUser(userId) {
      const getUser = doc(fb.db, "users", userId);
      const user = await getDoc(getUser);
      return user.data();
    },
    fetchUsers({ commit, state }) {
      const usersCollection = query(
        collection(fb.db, "users"),
        //  orderBy("createdOn", "desc"),
        where("id", "not-in", [state.userProfile.id]),
        limit(state.limit)
      );
      onSnapshot(usersCollection, (snapshot) => {
        let usersArray = [];

        snapshot.forEach((doc) => {
          let user = doc.data();
          user.id = doc.id;

          usersArray.push(user);
        });

        commit("setUsers", usersArray);
      });
    },
    // eslint-disable-next-line no-unused-vars
    async login({ commit, dispatch }, form) {
      commit("setError", null);
      signInWithEmailAndPassword(fb.auth, form.email, form.password)
        .then((user) => {
          dispatch("fetchUserProfile", user);
        })
        .catch((error) => commit("setError", error));
    },
    async fetchUserProfile({ commit }, user) {
      const getUserProfile = doc(fb.db, "users", user.uid);
      const userProfile = await getDoc(getUserProfile);
      commit("setUserProfile", { ...userProfile.data() });
      if (
        router.currentRoute.value.path === "/login" ||
        router.currentRoute.value.path === "/register"
      ) {
        if(router.currentRoute.value.query.redirect){
        router.push(router.currentRoute.value.query.redirect);}
        else{
          router.push('/')
        }
      }
    },
    async signup({ commit, dispatch }, form) {
      commit("setError", null);

      try {
        const { user } = await createUserWithEmailAndPassword(
          fb.auth,
          form.email,
          form.password
        );
        await setDoc(doc(fb.db, "users", user.uid), {
          id: user.uid,
          photo: "",
          email: form.email,
          name: form.name,
          arrayName: graphemeSplitter.splitGraphemes(form.name),
          phone: "",
          sex: "",
          hometown: "",
          about: "",
          follower: [],
          following: [],
          intruction: true,
        });

        dispatch("fetchUserProfile", user);
      } catch (error) {
        commit("setError", error);
      }
    },
    async logout({ commit }) {
      await fb.auth.signOut();
      commit("setUserProfile", {});
      router.push("/login");
    },
    async createPost({ state }, post) {
      await addDoc(collection(fb.db, "posts"), {
        createdOn: Date.now(),
        content: post.content,
        type: post.type,
        userId: fb.auth.currentUser.uid,
        userName: state.userProfile.name,
        userPhoto: state.userProfile.photo,
        comments: 0,
        likes: [],
        visibleComments: false,
      });
    },
    async addNotif({ state }, postNotif) {
      const userId = fb.auth.currentUser.uid;
      const userName = state.userProfile.name;
      const newNotif = {
        createdOn: Date.now(),
        type: postNotif.type,
        postId: postNotif.postId,
        userId: userId,
        targetUserId: postNotif.userId,
        name: userName,
        read: false,
        splashMessage: true,
      };
      await addDoc(collection(fb.db, "notifications"), newNotif);
    },
    async addComment({ state }, postComment) {
      const userId = fb.auth.currentUser.uid;
      const userName = state.userProfile.name;
      const newComment = {
        createdOn: Date.now(),
        content: postComment.text,
        postId: postComment.postId,
        userId: userId,
        name: userName,
        userPhoto: state.userProfile.photo,
      };
      await addDoc(collection(fb.db, "comments"), newComment);
      await updateDoc(doc(fb.db, "posts", postComment.postId), {
        comments: increment(1),
      });
    },
    // eslint-disable-next-line no-unused-vars
    async likePost({ commit, dispatch }, postNotif) {
      const userId = fb.auth.currentUser.uid;
      const post = await getDoc(doc(fb.db, "posts", postNotif.postId));
      const likesArr = post.data().likes;
      if (likesArr.includes(userId)) {
        await updateDoc(doc(fb.db, "posts", postNotif.postId), {
          likes: likesArr.filter((val) => val !== userId),
        });
        if (userId != postNotif.userId) {
          const notifDocs = await getDocs(
            query(
              collection(fb.db, "notifications"),
              where("postId", "==", postNotif.postId),
              where("userId", "==", userId)
            )
          );
          notifDocs.forEach(async (docs) => {
            if (docs.data().type == "like") {
              await deleteDoc(doc(fb.db, "notifications", docs.id));
            }
          });
        }
      } else {
        await updateDoc(doc(fb.db, "posts", postNotif.postId), {
          likes: likesArr.concat(userId).slice(0),
        });
        if (userId != postNotif.userId) {
          await dispatch("addNotif", postNotif);
        }
      }
    },

    // eslint-disable-next-line no-unused-vars
    async unfollowUser({ dispatch, commit, state }, targetUserId) {
      const user = state.userProfile;
      const targetUser = await getDoc(doc(fb.db, "users", targetUserId));
      const targetFollower = targetUser.data().follower;
      await updateDoc(doc(fb.db, "users", targetUserId), {
        follower: targetFollower.filter((val) => val !== user.id),
      });
      await updateDoc(doc(fb.db, "users", user.id), {
        following: user.following.filter((val) => val !== targetUserId),
      });
      await dispatch("fetchUserProfile", { uid: user.id });
      await store.dispatch("fetchAllPosts");
    },
    // eslint-disable-next-line no-unused-vars
    async followUser({ dispatch, commit, state }, targetUserId) {
      const userId = fb.auth.currentUser.uid;
      const user = state.userProfile;
      const newNotif = {
        createdOn: Date.now(),
        type: "follow",
        postId: null,
        userId: userId,
        targetUserId: targetUserId,
        name: user.name,
        read: false,
        splashMessage: true,
      };
      const targetUser = await getDoc(doc(fb.db, "users", targetUserId));
      const targetFollower = targetUser.data().follower;
      await updateDoc(doc(fb.db, "users", targetUserId), {
        follower: targetFollower.concat(userId).slice(0),
      });
      await updateDoc(doc(fb.db, "users", userId), {
        following: user.following.concat(targetUserId).slice(0),
      });
      await dispatch("fetchUserProfile", { uid: userId });
      await store.dispatch("fetchAllPosts");
      await addDoc(collection(fb.db, "notifications"), newNotif);
    },

    // eslint-disable-next-line no-unused-vars
    async answeredGuess(postId) {
      const userId = fb.auth.currentUser.uid;
      const post = await getDoc(doc(fb.db, "posts", postId));
      const userAnswered = post.data().content.answered;
      await updateDoc(doc(fb.db, "posts", postId), {
        content: { answered: userAnswered.concat(userId).slice(0) },
      });
    },
    async closeSplashMessage({ commit }, notifId) {
      await updateDoc(doc(fb.db, "notifications", notifId), {
        splashMessage: false,
      });
      commit("setSplash", null);
    },
    // eslint-disable-next-line no-unused-vars
    async deletePost({ commit }, postId) {
      // TODO: add snackbar with message instead of console.log
      const docRef = doc(fb.db, "posts", postId);
      await deleteDoc(docRef);
    },
    // eslint-disable-next-line no-unused-vars
    async updatePost({ commit }, post) {
      // TODO: add snackbar with message instead of console.log
    
      await updateDoc(doc(fb.db, "posts", post.id), {
        content: {
          status: post.value.content.status,
          image: post.value.content.image,
        },
      });
    },
    async updatePhotoProfile({ dispatch }, imgUrl) {
      const userId = fb.auth.currentUser.uid;
      await updateDoc(doc(fb.db, "users", userId), {
        photo: imgUrl,
      });
      dispatch("fetchUserProfile", { uid: userId });
      const postDocs = query(
        collection(fb.db, "posts"),
        where("userId", "==", userId)
      );
      const commentDocs = query(
        collection(fb.db, "comments"),
        where("userId", "==", userId)
      );
      const getPostDocs = await getDocs(postDocs);
      getPostDocs.forEach(async (docs) => {
        await updateDoc(doc(fb.db, "posts", docs.id), {
          userPhoto: imgUrl,
        });
      });
      const getCommentDocs = await getDocs(commentDocs);
      getCommentDocs.forEach(async (docs) => {
        await updateDoc(doc(fb.db, "comments", docs.id), {
          userPhoto: imgUrl,
        });
      });
    },
    async updateProfile({ dispatch }, user) {
      const userId = fb.auth.currentUser.uid;
      await updateDoc(doc(fb.db, "users", userId), {
        name: user.name,
        phone: user.phone,
        hometown: user.hometown,
        sex: user.sex,
        about: user.about,
      });

      dispatch("fetchUserProfile", { uid: userId });

      const postDocs = query(
        collection(fb.db, "posts"),
        where("userId", "==", userId)
      );
      const commentDocs = query(
        collection(fb.db, "comments"),
        where("userId", "==", userId)
      );
      const getPostDocs = await getDocs(postDocs);
      getPostDocs.forEach(async (docs) => {
        await updateDoc(doc(fb.db, "posts", docs.id), {
          userName: user.name,
        });
      });

      const getCommentDocs = await getDocs(commentDocs);
      getCommentDocs.forEach(async (docs) => {
        await updateDoc(doc(fb.db, "comments", docs.id), {
          name: user.name,
        });
      });
    },
  },
  modules: {},
});

export default store;
